import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { areEqual } from 'Utils/equalityChecks';

import { RocketPayCompanyModel } from 'Containers/User/Models/RocketPayModel/RocketPayCompanyModel';
import { firstCompanyIdSelector } from 'Containers/Projects/selectors';

import { webComponentTokenSelector } from 'Containers/RocketPay/selectors';
import { RocketPayPayouts } from 'Components/RocketPay/RocketPayPayouts';
import { fetchWebComponentToken } from '../actions';

interface Props {
  companyInfo: RocketPayCompanyModel;
}

function RocketPayPayoutsContainer({ companyInfo }: Props) {
  const dispatch = useDispatch();

  const webToken = useSelector(webComponentTokenSelector, areEqual);

  const firstCompanyId = useSelector(firstCompanyIdSelector, areEqual);

  useEffect(() => {
    dispatch(fetchWebComponentToken(firstCompanyId));
  }, [dispatch, firstCompanyId]);

  return <RocketPayPayouts companyInfo={companyInfo} authToken={webToken} />;
}

const RocketPayPayoutsContainerMemo = memo(RocketPayPayoutsContainer, areEqual);

export { RocketPayPayoutsContainerMemo as RocketPayPayouts };
